import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ForYouOrNot() {
  const forYou = ['Quieres empezar a sentirte mejor sin cambios imposibles', 'Sospechas que tu cuerpo vive inflamado', 'Estás cansada de leer información suelta en internet', 'Buscas una guía clara, práctica y aplicable', 'Quieres un enfoque femenino, integral y realista', 'Necesitas orden y dirección en lugar de confusión'];
  const notForYou = ['Buscas una solución mágica de un día para otro', 'No estás dispuesta a aplicar pequeños cambios', 'Esperas promesas irreales o garantías absolutas', 'No quieres comprometerte con un proceso de 3 semanas'];
  return <section className="w-full px-4 py-20 bg-ivory" data-id="element-90">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-91">
        {/* PARA TI SI */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-sage/10 p-8 md:p-10 rounded-3xl border border-sage/20" data-id="element-92">
          <h2 className="text-3xl font-serif text-sage mb-8" data-id="element-93">
            Es para ti si...
          </h2>
          <ul className="space-y-5" data-id="element-94">
            {forYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-95">
                <Check className="w-5 h-5 text-sage shrink-0 mt-0.5" data-id="element-96" />
                <span className="text-ink/90 font-medium" data-id="element-97">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* NO ES PARA TI SI */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-cream p-8 md:p-10 rounded-3xl border border-taupe/10" data-id="element-98">
          <h2 className="text-3xl font-serif text-muted mb-8" data-id="element-99">
            No es para ti si...
          </h2>
          <ul className="space-y-5" data-id="element-100">
            {notForYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-101">
                <X className="w-5 h-5 text-muted shrink-0 mt-0.5" data-id="element-102" />
                <span className="text-ink/70" data-id="element-103">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}